import ChatWidget from "@/components/ChatWidget";
//import { GetMedicalOrderMessages, SendMedicalOrderMessage } from "@/api/endpoints/Broker/BrokerRequest";
import "./style.css";

interface ChatWrapperProps {
    providerOrderId: string | number;
        className?: string;
    popupRef: React.RefObject<any>;
    isChatOpen: boolean;
    setIsChatOpen: (isChatOpen: boolean) => void;
    setOpednedFiles: (OpednedFiles: any) => void;
}

const ChatWrapper: React.FC<ChatWrapperProps> = ({ 
    providerOrderId, 
    className = "",
    popupRef,
    isChatOpen,
    setIsChatOpen,
    setOpednedFiles
}) => {
    return (
        <div className={`chat-wrapper-container ${className}`}>
   {/*          <ChatWidget 
                providerOrderId={providerOrderId}
                popupRef={popupRef}
                sendMessageAPI={SendMedicalOrderMessage}
                getMessagesAPI={GetMedicalOrderMessages}
                setIsChatOpen={setIsChatOpen}
                isChatOpen={isChatOpen}
                setOpednedFiles={setOpednedFiles}
            /> */}
        </div>
    );
};

export default ChatWrapper;
